import { useEffect, useMemo, useRef, useState } from "react";

const pickAuto = (rends) => {
  const c = typeof navigator !== "undefined" ? navigator.connection : null;
  const slow = c && (/2g|3g/.test(c.effectiveType || "") || (c.downlink && c.downlink < 2) || c.saveData);
  const wide = typeof window !== "undefined" && window.innerWidth >= 1280;
  const want = slow ? 360 : wide ? 1080 : 720;
  return [...rends].sort((a, b) => Math.abs(a.height - want) - Math.abs(b.height - want))[0];
};

/** <video> with a quality switch (Auto / 360p / 720p / 1080p) that keeps the playhead when switching. */
export function QualityVideo({ post, testId = "stage-video" }) {
  const rends = post.renditions || [];
  const [choice, setChoice] = useState("auto");
  const ref = useRef(null);
  const src = useMemo(() => {
    if (!rends.length) return post.media_url;
    const r = choice === "auto" ? pickAuto(rends) : rends.find((x) => x.label === choice) || rends[rends.length - 1];
    return r?.url || post.media_url;
  }, [rends, choice, post.media_url]);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    const t = v.currentTime, playing = !v.paused;
    v.src = src;
    v.load();
    if (t > 0) v.currentTime = t;
    if (playing) v.play().catch(() => {});
  }, [src]);

  return (
    <div className="relative h-full w-full flex items-center justify-center">
      <video ref={ref} controls autoPlay playsInline poster={post.cover_url || undefined} className="max-h-full w-full object-contain" data-testid={testId} />
      {rends.length > 1 && (
        <div className="absolute bottom-14 right-2 md:top-2 md:bottom-auto flex gap-1 rounded-full bg-black/60 backdrop-blur px-1 py-1" data-testid="quality-picker">
          {["auto", ...rends.map((r) => r.label)].map((q) => (
            <button key={q} onClick={() => setChoice(q)} data-testid={`quality-${q}`}
              className={`px-2 py-0.5 rounded-full text-[10px] font-bold uppercase ${choice === q ? "bg-white text-black" : "text-white/80 hover:text-white"}`}>{q}</button>
          ))}
        </div>
      )}
      {post.transcode && post.transcode !== "done" && !rends.length && (
        <div className="absolute bottom-2 left-2 rounded-full bg-black/60 px-2 py-0.5 text-[10px] text-white/80" data-testid="transcode-status">
          {post.transcode === "failed" ? "original quality" : "optimising quality…"}
        </div>
      )}
    </div>
  );
}
